import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { SettingsFacilitiesRoute } from './SettingsFacilitiesRoute';
import { SettingsFacilityBorrowingBaseConfigurationRoute } from './SettingsFacilityBorrowingBaseConfigurationRoute';
import { SettingsFacilityBorrowingBaseLoanTapeRoute } from './SettingsFacilityBorrowingBaseLoanTapeRoute';
import { SettingsFacilityBorrowingBaseSandboxRoute } from './SettingsFacilityBorrowingBaseSandboxRoute';
import { SettingsFacilityPortfolioCovenantsConfigurationRoute } from './SettingsFacilityPortfolioCovenantsConfigurationRoute';
import { SettingsFacilityPortfolioCovenantsEditRoute } from './SettingsFacilityPortfolioCovenantsEditRoute';
import { SettingsUserRoute } from './SettingsUserRoute';
import { settingsPaths } from 'packages/sidebar/ui/sideBarUtils';

export const SettingsRouter = withLDConsumer()(({ flags }) => {
  const displayLenderSettingsFacilities = !!flags?.displayLenderSettingsFacilities;
  const enableLenderBaseFieldEdits =
    displayLenderSettingsFacilities && !!flags?.enableLenderBaseFieldEdits;

  return (
    <Switch>
      <Route exact path={settingsPaths.account} component={SettingsUserRoute} />
      {displayLenderSettingsFacilities && (
        <Route
          exact
          path={settingsPaths.facilities}
          component={SettingsFacilitiesRoute}
        />
      )}

      {/* Credit Agreement Borrowing Base Routes */}
      {displayLenderSettingsFacilities && (
        <Route exact path={settingsPaths.facilitiesBorrowingBaseConfiguration}>
          <SettingsFacilityBorrowingBaseConfigurationRoute />
        </Route>
      )}
      {displayLenderSettingsFacilities && (
        <Route exact path={settingsPaths.facilitiesBorrowingBaseSandbox}>
          <SettingsFacilityBorrowingBaseSandboxRoute />
        </Route>
      )}
      {enableLenderBaseFieldEdits && (
        <Route exact path={settingsPaths.facilitiesBorrowingBaseLoanTape}>
          <SettingsFacilityBorrowingBaseLoanTapeRoute />
        </Route>
      )}

      {displayLenderSettingsFacilities && (
        <Route exact path={settingsPaths.facilitiesBorrowingBase}>
          <Redirect
            from={settingsPaths.facilitiesBorrowingBase}
            to={settingsPaths.facilitiesBorrowingBaseConfiguration}
          />
        </Route>
      )}

      {/* Credit Agreement Portfolio Covenants Routes */}
      {displayLenderSettingsFacilities && flags.displayPortfolioCovenants && (
        <Route
          exact
          path={settingsPaths.facilitiesPortfolioCovenantsConfiguration}
        >
          <SettingsFacilityPortfolioCovenantsConfigurationRoute />
        </Route>
      )}
      {displayLenderSettingsFacilities && flags.displayPortfolioCovenants && (
        <Route exact path={settingsPaths.facilitiesPortfolioCovenantsEdit}>
          <SettingsFacilityPortfolioCovenantsEditRoute />
        </Route>
      )}
      {displayLenderSettingsFacilities && flags.displayPortfolioCovenants && (
        <Route exact path={settingsPaths.facilitiesPortfolioCovenants}>
          <Redirect
            from={settingsPaths.facilitiesPortfolioCovenants}
            to={settingsPaths.facilitiesPortfolioCovenantsConfiguration}
          />
        </Route>
      )}

      <Route exact path={settingsPaths.settings}>
        <Redirect from={settingsPaths.settings} to={settingsPaths.account} />
      </Route>
    </Switch>
  );
});
